import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-not-found',
  template: '<div class="conteudo"><h1 style="color#fff;">Página não encontrada.</h1>'
})
export class NotFoundComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
